import { render, staticRenderFns } from "./CompanyModal.vue?vue&type=template&id=00d29b98&"
import script from "./CompanyModal.vue?vue&type=script&lang=ts&"
export * from "./CompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports